var Getters = {// [types.GETTER_ROUTER_STACK_INCLUDE_NAME](state, getters, rootState) {
  //   return (payLoad: string) => {
  //     const { routeStack } = state;
  //     const findRoute = routeStack.find((route: any) => {
  //       return route.name === payLoad;
  //     });
  //     if (findRoute === undefined || findRoute === null) {
  //       return false;
  //     } else {
  //       return findRoute;
  //     }
  //   };
  // },
  // [types.GETTER_ROUTER_STACK](state) {
  //   return state.routeStack
  // },
  // [types.GETTER_ROUTER_STACK_INCLUDE_TIMES](state, getters, rootstate) {
  //   return (payLoad: string) => {
  //     const { routeStack } = state;
  //     let nums: number = 0;
  //     for(const route of routeStack) {
  //       if (route.name === payLoad) {
  //         nums++
  //       }
  //     }
  //     return nums
  //   }
  // }
};
export default Getters;